export const messageIcons = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M7 9H17M7 13H12M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const phoneIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M21 5.5C21 14.0604 14.0604 21 5.5 21C5.11378 21 4.73086 20.9859 4.35172 20.9581C3.91662 20.9262 3.69906 20.9103 3.50103 20.7963C3.33701 20.7019 3.18146 20.5345 3.09925 20.364C3 20.1582 3 19.9181 3 19.438V16.6207C3 16.2169 3 16.015 3.06645 15.842C3.12515 15.6891 3.22049 15.553 3.3441 15.4456C3.48403 15.324 3.67376 15.255 4.05321 15.117L7.26005 13.9509C7.70153 13.7904 7.92227 13.7101 8.1317 13.7237C8.31637 13.7357 8.49408 13.7988 8.64506 13.9058C8.81628 14.0271 8.93713 14.2285 9.17882 14.6314L10 16C12.6499 14.7999 14.7981 12.6489 16 10L14.6314 9.17882C14.2285 8.93713 14.0271 8.81628 13.9058 8.64506C13.7988 8.49408 13.7357 8.31637 13.7237 8.1317C13.7101 7.92227 13.7904 7.70153 13.9509 7.26005L13.9509 7.26005L15.117 4.05321C15.255 3.67376 15.324 3.48403 15.4456 3.3441C15.553 3.22049 15.6891 3.12515 15.842 3.06645C16.015 3 16.2169 3 16.6207 3H19.438C19.9181 3 20.1582 3 20.364 3.09925C20.5345 3.18146 20.7019 3.33701 20.7963 3.50103C20.9103 3.69907 20.9262 3.91662 20.9581 4.35173C20.9859 4.73086 21 5.11378 21 5.5Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const mailIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M4 7L10.94 11.3375C11.5885 11.7428 12.4115 11.7428 13.06 11.3375L20 7M5 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const depositIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M12 3V9M12 3L9.5 5.5M12 3L14.5 5.5M5.82333 9.00037C6.2383 9.36683 6.5 9.90285 6.5 10.5C6.5 11.6046 5.60457 12.5 4.5 12.5C3.90285 12.5 3.36683 12.2383 3.00037 11.8233M5.82333 9.00037C5.94144 9 6.06676 9 6.2 9H8M5.82333 9.00037C4.94852 9.00308 4.46895 9.02593 4.09202 9.21799C3.71569 9.40973 3.40973 9.71569 3.21799 10.092C3.02593 10.469 3.00308 10.9485 3.00037 11.8233M3.00037 11.8233C3 11.9414 3 12.0668 3 12.2V17.8C3 17.9332 3 18.0586 3.00037 18.1767M3.00037 18.1767C3.36683 17.7617 3.90285 17.5 4.5 17.5C5.60457 17.5 6.5 18.3954 6.5 19.5C6.5 20.0971 6.2383 20.6332 5.82333 20.9996M3.00037 18.1767C3.00308 19.0515 3.02593 19.5311 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.46895 20.9741 4.94852 20.9969 5.82333 20.9996M5.82333 20.9996C5.94144 21 6.06676 21 6.2 21H17.8C17.9332 21 18.0586 21 18.1767 20.9996M21 18.1771C20.6335 17.7619 20.0973 17.5 19.5 17.5C18.3954 17.5 17.5 18.3954 17.5 19.5C17.5 20.0971 17.7617 20.6332 18.1767 20.9996M21 18.1771C21.0004 18.0589 21 17.9334 21 17.8V12.2C21 12.0668 21 11.9414 20.9996 11.8233M21 18.1771C20.9973 19.0516 20.974 19.5311 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.5311 20.9741 19.0515 20.9969 18.1767 20.9996M20.9996 11.8233C20.6332 12.2383 20.0971 12.5 19.5 12.5C18.3954 12.5 17.5 11.6046 17.5 10.5C17.5 9.90285 17.7617 9.36683 18.1767 9.00037M20.9996 11.8233C20.9969 10.9485 20.9741 10.469 20.782 10.092C20.5903 9.71569 20.2843 9.40973 19.908 9.21799C19.5311 9.02593 19.0515 9.00308 18.1767 9.00037M18.1767 9.00037C18.0586 9 17.9332 9 17.8 9H16M14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const commentIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-8.96 -8.96 49.92 49.92"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-8.96"
        y="-8.96"
        width="49.92"
        height="49.92"
        rx="24.96"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <title>comment-4</title> <desc>Created with Sketch Beta.</desc>{" "}
      <defs> </defs>{" "}
      <g id="Page-1" strokeWidth="1.28" fill="none" fillRule="evenodd">
        {" "}
        <g
          id="Icon-Set"
          transform="translate(-308.000000, -255.000000)"
          fill="#000000"
        >
          {" "}
          <path
            d="M327.494,279.633 L324,284 L320.506,279.633 C314.464,278.355 309.992,273.863 309.992,268.501 C309.992,262.146 316.264,256.994 324,256.994 C331.736,256.994 338.008,262.146 338.008,268.501 C338.008,273.863 333.536,278.355 327.494,279.633 L327.494,279.633 Z M324,255 C315.163,255 308,261.143 308,268.72 C308,274.969 312.877,280.232 319.542,281.889 L324,287.001 L328.459,281.889 C335.123,280.232 340,274.969 340,268.72 C340,261.143 332.837,255 324,255 L324,255 Z"
            id="comment-4"
          >
            {" "}
          </path>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
);

export const clockIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M12 17V12L14.5 10.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);
export const teamIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M18 19V18C18 15.7909 16.2091 14 14 14H10C7.79086 14 6 15.7909 6 18V19M23 19V18C23 15.7909 21.2091 14 19 14H18.5M1 19V18C1 15.7909 2.79086 14 5 14H5.5M17 11C18.6569 11 20 9.65685 20 8C20 6.34315 18.6569 5 17 5M7 11C5.34315 11 4 9.65685 4 8C4 6.34315 5.34315 5 7 5M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z"
        className="dark:stroke-white "
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);
export const clientIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const rolesIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g strokeWidth="0"></g>
    <g strokeLinecap="round" strokeLinejoin="round"></g>
    <g>
      {/* User */}
      <path
        d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Body */}
      <path
        d="M5 20C5 16.6863 8.13401 14 12 14C15.866 14 19 16.6863 19 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      {/* Role nodes */}
      <circle
        cx="4.5"
        cy="12"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="19.5"
        cy="12"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Connections */}
      <path
        d="M6 12H8M16 12H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const coldIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M11.9994 3V7M11.9994 7V17M11.9994 7L8.99943 4M11.9994 7L14.9994 4M11.9994 17V21M11.9994 17L8.99943 20M11.9994 17L14.9994 20M4.20624 7.49999L7.67034 9.49999M7.67034 9.49999L16.3306 14.5M7.67034 9.49999L3.57227 10.5981M7.67034 9.49999L6.57227 5.40191M16.3306 14.5L19.7947 16.5M16.3306 14.5L17.4287 18.5981M16.3306 14.5L20.4287 13.4019M4.2067 16.5L7.6708 14.5M7.6708 14.5L16.3311 9.49999M7.6708 14.5L3.57273 13.4019M7.6708 14.5L6.57273 18.5981M16.3311 9.49999L19.7952 7.49999M16.3311 9.49999L17.4291 5.40192M16.3311 9.49999L20.4291 10.5981"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);
export const payoutIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M12 4L12 20M12 4L18 10M12 4L6 10"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const historyIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    className="dark:fill-white "
    fill="#000000"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M3,23a1,1,0,0,1-1-1V2A1,1,0,0,1,4,2V3H8A1,1,0,0,1,8,5H4v6h8a1,1,0,0,1,0,2H4v6H6a1,1,0,0,1,0,2H4v1A1,1,0,0,1,3,23ZM21,3H13V2a1,1,0,0,0-2,0V4h0V6a1,1,0,0,0,2,0V5h8a1,1,0,0,0,0-2Zm0,8H17V10a1,1,0,0,0-2,0v2h0v2a1,1,0,0,0,2,0V13h4a1,1,0,0,0,0-2Zm0,8H11V18a1,1,0,0,0-2,0v2H9v2a1,1,0,0,0,2,0V21H21a1,1,0,0,0,0-2Z"></path>
    </g>
  </svg>
);

export const chainIcon = (w = "80px", h = "80px") => (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#000000"
    strokeWidth="0.9600000000000002"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokewidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        opacity="0.5"
        d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
        fill="#1C274C"
      ></path>{" "}
      <path
        d="M8 17C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17Z"
        fill="#1C274C"
      ></path>{" "}
      <path
        d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
        fill="#1C274C"
      ></path>{" "}
      <path
        d="M17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z"
        fill="#1C274C"
      ></path>{" "}
      <path
        d="M6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C17.8174 10.0089 18.3135 10.022 18.75 10.0546V8C18.75 4.27208 15.7279 1.25 12 1.25C8.27208 1.25 5.25 4.27208 5.25 8V10.0546C5.68651 10.022 6.18264 10.0089 6.75 10.0036V8Z"
        fill="#1C274C"
      ></path>{" "}
    </g>
  </svg>
);
export const lockIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);
export const envelopeIcon = (w = "80px", h = "80px") => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={w}
    height={h}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        className="dark:stroke-white"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
      ></rect>{" "}
    </g>
  </svg>
);

export const newUserIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.4 -2.4 28.80 28.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.4"
        y="-2.4"
        width="28.80"
        height="28.80"
        rx="14.4"
        fill="#ffffff"
        strokewidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M20 18L17 18M17 18L14 18M17 18V15M17 18V21M11 21H4C4 17.134 7.13401 14 11 14C11.695 14 12.3663 14.1013 13 14.2899M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
        stroke="#000000"
        strokeWidth="0.9600000000000002"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);
export const smsIcon = (w = "80px", h = "80px") => (
  <svg
    width="90px"
    height="90px"
    viewBox="-7.92 -7.92 39.84 39.84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#ffffff"
    strokeWidth="0.00024000000000000003"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-7.92"
        y="-7.92"
        width={w}
        height={h}
        rx="19.92"
        fill="#0080ff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M7 7.5C6.44772 7.5 6 7.94772 6 8.5C6 9.05228 6.44772 9.5 7 9.5H15C15.5523 9.5 16 9.05228 16 8.5C16 7.94772 15.5523 7.5 15 7.5H7Z"
        fill="#ffffff"
      ></path>{" "}
      <path
        d="M6 12.5C6 11.9477 6.44772 11.5 7 11.5H17C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5H7C6.44772 13.5 6 13.0523 6 12.5Z"
        fill="#ffffff"
      ></path>{" "}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.5C4.23858 2.5 2 4.73858 2 7.5V13.5C2 16.2614 4.23858 18.5 7 18.5H8.58579L11.2929 21.2071C11.6834 21.5976 12.3166 21.5976 12.7071 21.2071L15.4142 18.5H17C19.7614 18.5 22 16.2614 22 13.5V7.5C22 4.73858 19.7614 2.5 17 2.5H7ZM4 7.5C4 5.84315 5.34315 4.5 7 4.5H17C18.6569 4.5 20 5.84315 20 7.5V13.5C20 15.1569 18.6569 16.5 17 16.5H7C5.34315 16.5 4 15.1569 4 13.5V7.5Z"
        fill="#ffffff"
      ></path>{" "}
    </g>
  </svg>
);

export const callIcon = (w = "80px", h = "80px") => (
  <svg
    width="90px"
    height="90px"
    viewBox="-8.4 -8.4 40.80 40.80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-8.4"
        y="-8.4"
        width={w}
        height={h}
        rx="20.4"
        fill="green"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M3 5.5C3 14.0604 9.93959 21 18.5 21C18.8862 21 19.2691 20.9859 19.6483 20.9581C20.0834 20.9262 20.3009 20.9103 20.499 20.7963C20.663 20.7019 20.8185 20.5345 20.9007 20.364C21 20.1582 21 19.9181 21 19.438V16.6207C21 16.2169 21 16.015 20.9335 15.842C20.8749 15.6891 20.7795 15.553 20.6559 15.4456C20.516 15.324 20.3262 15.255 19.9468 15.117L16.74 13.9509C16.2985 13.7904 16.0777 13.7101 15.8683 13.7237C15.6836 13.7357 15.5059 13.7988 15.3549 13.9058C15.1837 14.0271 15.0629 14.2285 14.8212 14.6314L14 16C11.3501 14.7999 9.2019 12.6489 8 10L9.36863 9.17882C9.77145 8.93713 9.97286 8.81628 10.0942 8.64506C10.2012 8.49408 10.2643 8.31637 10.2763 8.1317C10.2899 7.92227 10.2096 7.70153 10.0491 7.26005L8.88299 4.05321C8.745 3.67376 8.67601 3.48403 8.55442 3.3441C8.44701 3.22049 8.31089 3.12515 8.15802 3.06645C7.98496 3 7.78308 3 7.37932 3H4.56201C4.08188 3 3.84181 3 3.63598 3.09925C3.4655 3.18146 3.29814 3.33701 3.2037 3.50103C3.08968 3.69907 3.07375 3.91662 3.04189 4.35173C3.01413 4.73086 3 5.11378 3 5.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
);

export const whatsappIcon = (w = "80px", h = "80px") => (
  <svg
    height={h}
    width={w}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="#75B73B"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <circle
        style={{ fill: "#00005B73B" }}
        cx="256"
        cy="256"
        r="256"
      ></circle>{" "}
      <path
        style={{ fill: "#0000" }}
        d="M360.241,151.826c-14.843-3.712-36.671-16.532-50.8-21.671 c-55.165-17.239-129.293-3.448-149.98,60.337c-1.724,1.724-5.172,1.724-6.896,1.724c-41.374,48.269-13.791,106.882-17.239,160.323 c-1.177,18.839-11.083,35.497-23.831,49.588l107.282,107.17C230.931,511.067,243.355,512,256,512 c126.436,0,231.452-91.665,252.247-212.161L360.241,151.826z"
      ></path>{" "}
      <g>
        {" "}
        <path
          style={{ fill: "#FFFFFF" }}
          d="M248.837,108.447c-78.029,3.712-139.604,68.696-139.369,146.811 c0.072,23.792,5.816,46.249,15.95,66.095l-15.557,75.514c-0.841,4.086,2.843,7.663,6.901,6.701l73.995-17.53 c19.011,9.471,40.364,14.939,62.962,15.284c79.753,1.219,146.251-62.105,148.74-141.829 C405.121,174.035,334.591,104.362,248.837,108.447L248.837,108.447z M337.13,335.936c-21.669,21.669-50.483,33.604-81.13,33.604 c-17.944,0-35.126-4.027-51.066-11.966l-10.302-5.134l-45.37,10.747l9.549-46.356l-5.075-9.943 c-8.276-16.206-12.472-33.728-12.472-52.084c0-30.648,11.935-59.459,33.604-81.13c21.476-21.478,50.759-33.604,81.134-33.604 c30.644,0,59.458,11.935,81.127,33.604c21.669,21.669,33.604,50.483,33.604,81.127C370.735,285.177,358.607,314.459,337.13,335.936 L337.13,335.936z"
        ></path>{" "}
        <path
          style={{ fill: "#FFFFFF" }}
          d="M327.115,286.582l-28.384-8.149c-3.729-1.069-7.749-0.01-10.468,2.76l-6.942,7.07 c-2.926,2.984-7.366,3.941-11.24,2.374c-13.427-5.434-41.672-30.548-48.881-43.106c-2.084-3.624-1.739-8.152,0.817-11.462 l6.058-7.839c2.374-3.07,2.874-7.197,1.305-10.747l-11.941-27.008c-2.86-6.468-11.126-8.352-16.527-3.784 c-7.921,6.701-17.32,16.88-18.461,28.16c-2.015,19.887,6.515,44.954,38.762,75.055c37.257,34.778,67.094,39.369,86.523,34.664 c11.019-2.667,19.825-13.365,25.379-22.126C336.906,296.467,333.91,288.535,327.115,286.582L327.115,286.582z"
        ></path>{" "}
      </g>{" "}
      <g>
        {" "}
        <path
          style={{ fill: "#0000" }}
          d="M356.004,147.708l-22.223,22.778c1.131,1.045,2.257,2.096,3.351,3.191 c21.67,21.669,33.604,50.483,33.604,81.127c0,30.375-12.128,59.656-33.604,81.134c-21.669,21.669-50.483,33.604-81.13,33.604 c-17.944,0-35.125-4.027-51.066-11.966l-10.302-5.134l-45.37,10.747l0.938-4.553l-40.174,41.172 c0.886,2.663,3.705,4.475,6.734,3.758l73.995-17.53c19.011,9.471,40.364,14.939,62.962,15.284 c79.753,1.219,146.253-62.105,148.74-141.829C403.834,215.357,385.686,175.435,356.004,147.708z"
        ></path>{" "}
        <path
          style={{ fill: "#0000" }}
          d="M327.115,286.582l-28.384-8.149c-3.729-1.069-7.749-0.01-10.468,2.76l-6.942,7.07 c-2.926,2.984-7.366,3.941-11.24,2.374c-7.756-3.139-20.451-12.845-31.185-22.904l-19.732,20.225 c0.677,0.648,1.352,1.295,2.05,1.948c37.257,34.778,67.094,39.369,86.523,34.664c11.019-2.667,19.825-13.365,25.379-22.126 C336.906,296.467,333.91,288.535,327.115,286.582z"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
);

export const campaignIcon = (w = "80px", h = "80px") => (
  <svg
    fill="black"
    className="dark:fill-white"
    height={h}
    width={w}
    version="1.1"
    id="Capa_1"
    viewBox="0 0 236.108 236.108"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g>
        {" "}
        <path d="M7.5,69.21c-4.142,0-7.5,3.358-7.5,7.5v58.54c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V76.71 C15,72.568,11.642,69.21,7.5,69.21z"></path>{" "}
        <path d="M166.428,25.459h-31.204c-4.142,0-7.5,3.358-7.5,7.5v6.775L27.289,69.517c-3.184,0.944-5.368,3.87-5.368,7.19v58.512 c-0.002,0.375,0.034,0.753,0.09,1.132c0.01,0.07,0.02,0.14,0.032,0.209c0.056,0.31,0.124,0.62,0.221,0.928l21.261,67.9 c1.004,3.207,3.963,5.261,7.155,5.261c0.741,0,1.495-0.111,2.24-0.344l30.961-9.681c1.899-0.594,3.484-1.918,4.406-3.68 c0.923-1.762,1.107-3.819,0.513-5.718l-10.536-33.669l49.459,14.67v6.774c0,4.142,3.358,7.5,7.5,7.5h31.204 c4.142,0,7.5-3.358,7.5-7.5V32.959C173.928,28.817,170.57,25.459,166.428,25.459z M72.245,188.546l-16.646,5.205l-14.814-47.311 l20.154,5.977L72.245,188.546z M69.078,139.187c-0.021-0.006-0.043-0.013-0.064-0.019l-32.092-9.519V82.306l90.803-26.926v101.202 L69.078,139.187z M158.928,171.502h-16.204v-4.873V45.333v-4.873h16.204V171.502z"></path>{" "}
        <path d="M224.962,147.969l-32.452-16.229c-3.706-1.851-8.21-0.352-10.063,3.354c-1.853,3.705-0.351,8.21,3.354,10.063 l32.452,16.229c1.077,0.539,2.221,0.793,3.349,0.793c2.751,0,5.4-1.519,6.714-4.147 C230.168,154.327,228.666,149.822,224.962,147.969z"></path>{" "}
        <path d="M189.161,81.012c1.127,0,2.272-0.255,3.348-0.794l32.453-16.227c3.705-1.853,5.207-6.357,3.354-10.062 c-1.852-3.705-6.358-5.207-10.062-3.354l-32.453,16.227c-3.705,1.853-5.207,6.357-3.354,10.062 C183.761,79.493,186.41,81.012,189.161,81.012z"></path>{" "}
        <path d="M228.608,98.48h-27.098c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h27.098c4.142,0,7.5-3.358,7.5-7.5 C236.108,101.837,232.75,98.48,228.608,98.48z"></path>{" "}
      </g>{" "}
    </g>
  </svg>
);

export const newCampaignIcon = (w = "80px", h = "80px") => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 80 80"
    width={w}
    height={h}
    className="dark:fill-white"
  >
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M4.1,23.5c-1.4,0-2.5,1.1-2.5,2.5v19.8c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-19.8c0-1.4-1.1-2.5-2.5-2.5Z" />
        <path d="M56.4,8.6h-10.6c-1.4,0-2.5,1.1-2.5,2.5v2.3L9.2,23.6c-1.1.3-1.8,1.3-1.8,2.4v19.8c0,.1,0,.3,0,.4,0,0,0,0,0,0,0,.1,0,.2,0,.3l7.2,23c.3,1.1,1.3,1.8,2.4,1.8s.5,0,.8-.1l10.5-3.3c.6-.2,1.2-.6,1.5-1.2.3-.6.4-1.3.2-1.9l-3.6-11.4,16.8,5v2.3c0,1.4,1.1,2.5,2.5,2.5h10.6c1.4,0,2.5-1.1,2.5-2.5V11.2c0-1.4-1.1-2.5-2.5-2.5ZM24.5,63.9l-5.6,1.8-5-16,6.8,2,3.8,12.2ZM23.4,47.2s0,0,0,0l-10.9-3.2v-16l30.8-9.1v34.3l-19.9-5.9ZM53.8,58.1h-5.5V13.7h5.5v44.4Z" />
      </g>
    </g>
    <path d="M69.6,26.8c-1,0-1.9.8-1.9,1.9v14.4c0,1,.8,1.9,1.9,1.9s1.9-.8,1.9-1.9v-14.4c0-1-.8-1.9-1.9-1.9Z" />
    <path d="M78.7,35.9c0-1-.8-1.9-1.9-1.9h-14.4c-1,0-1.9.8-1.9,1.9s.8,1.9,1.9,1.9h14.4c1,0,1.9-.8,1.9-1.9Z" />
  </svg>
);

export const customerListIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={w}
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    fill="black"
    className="dark:fill-white"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M841.2 841.1H182.9V182.9h292.5v-73.2H109.7v804.6h804.6V621.7h-73.1z"
        fill="black"
        className="dark:fill-white"
      ></path>
      <path
        d="M402.3 585.1h73.1c0-100.8 82-182.9 182.9-182.9s182.9 82 182.9 182.9h73.1c0-102.2-60.2-190.6-147-231.6 23.2-25.9 37.3-60.1 37.3-97.5 0-80.8-65.5-146.3-146.3-146.3-80.8 0-146.3 65.5-146.3 146.3 0 37.5 14.1 71.7 37.3 97.5-86.8 41.1-147 129.4-147 231.6z m256-402.2c40.3 0 73.1 32.8 73.1 73.1s-32.8 73.1-73.1 73.1-73.1-32.8-73.1-73.1 32.8-73.1 73.1-73.1zM219.4 256h219.4v73.1H219.4zM219.4 658.3h585.1v73.1H219.4zM219.4 402.3h146.3v73.1H219.4z"
        fill="black"
        className="dark:fill-white"
      ></path>
    </g>
  </svg>
);
export const contractIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="-225.28 -225.28 1474.56 1474.56"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    stroke="#000000"
    strokeWidth="0.01024"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-225.28"
        y="-225.28"
        width="1474.56"
        height="1474.56"
        rx="737.28"
        fill="#ffffff"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M182.52 146.2h585.14v256h73.15V73.06H109.38v877.71h256v-73.14H182.52z"
        fill="#0F1F3C"
      ></path>
      <path
        d="M255.67 219.34h438.86v73.14H255.67zM255.67 365.63h365.71v73.14H255.67zM255.67 511.91H475.1v73.14H255.67zM775.22 458.24L439.04 794.42l-0.52 154.64 155.68 0.52L930.38 613.4 775.22 458.24z m51.72 155.16l-25.43 25.43-51.73-51.72 25.44-25.44 51.72 51.73z m-77.14 77.15L620.58 819.77l-51.72-51.72 129.22-129.22 51.72 51.72zM511.91 876.16l0.17-51.34 5.06-5.06 51.72 51.72-4.85 4.85-52.1-0.17z"
        fill="#0F1F3C"
      ></path>
    </g>
  </svg>
);

export const newStoresIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 64 64"
    strokeWidth="3"
    stroke="#000000"
    fill="none"
    className="dark:stroke-white"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M43.21,54.62H12a2.93,2.93,0,0,1-3-2.84V26.19"></path>
      <line x1="49.01" y1="26.36" x2="49.01" y2="37.37"></line>
      <polyline points="23.26 54.55 23.26 37.48 34.84 37.48 34.84 54.55"></polyline>
      <path d="M5.45,18.2s-1.1,7.76,6.45,9a7.15,7.15,0,0,0,6.1-2A7.43,7.43,0,0,0,29,25a7.37,7.37,0,0,0,5,2.49,11.77,11.77,0,0,0,5.89-2.15,6.67,6.67,0,0,0,4.68,2.15,8,8,0,0,0,7.92-9.3L47.79,8.08a1,1,0,0,0-.94-.66H11a1,1,0,0,0-.94.66Z"></path>
      <line x1="5.45" y1="18.2" x2="52.54" y2="18.2"></line>
      <line x1="18.05" y1="18.2" x2="18.05" y2="7.42"></line>
      <line x1="29.05" y1="18.2" x2="29.05" y2="7.42"></line>
      <line x1="40.02" y1="18.2" x2="40.02" y2="7.42"></line>
      <circle cx="49.01" cy="46.97" r="9.6"></circle>
      <polyline points="49.01 40.86 49.01 47.27 52.58 50.01"></polyline>
    </g>
  </svg>
);
export const renovationIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    fill="#000000"
    className="dark:fill-white"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M182.99 146.2h585.14v402.29h73.14V73.06H109.84v877.71H512v-73.14H182.99z"
        fill="#000000"
        className="dark:fill-white"
      ></path>
      <path
        d="M256.13 219.34h438.86v73.14H256.13zM256.13 365.63h365.71v73.14H256.13zM256.13 511.91h219.43v73.14H256.13zM731.55 585.06c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86c100.99 0 182.86-81.87 182.86-182.86s-81.86-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0.01 60.49-49.21 109.71-109.71 109.71z"
        fill="#000000"
        className="dark:fill-white"
      ></path>
      <path
        d="M758.99 692.08h-54.86v87.27l69.39 68.76 38.61-38.96-53.14-52.66z"
        fill="#000000"
        className="dark:fill-white"
      ></path>
    </g>
  </svg>
);

export const categoryShopIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 64 64"
    strokeWidth="3"
    stroke="#000000"
    fill="none"
    className="dark:stroke-white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g strokeLinecap="round" strokeLinejoin="round">
      <rect x="8" y="10" width="48" height="8" rx="2" ry="2"></rect>
      <rect x="8" y="28" width="48" height="8" rx="2" ry="2"></rect>
      <rect x="8" y="46" width="48" height="8" rx="2" ry="2"></rect>
      <circle cx="16" cy="14" r="1.5"></circle>
      <circle cx="16" cy="32" r="1.5"></circle>
      <circle cx="16" cy="50" r="1.5"></circle>
    </g>
  </svg>
);

export const categoryIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M6 7.5C6 6.94772 6.44772 6.5 7 6.5H17C17.5523 6.5 18 6.94772 18 7.5C18 8.05228 17.5523 8.5 17 8.5H7C6.44772 8.5 6 8.05228 6 7.5Z"
        fill="#ffffff"
      ></path>{" "}
      <path
        d="M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z"
        fill="#ffffff"
      ></path>{" "}
      <path
        d="M7 15.5C6.44772 15.5 6 15.9477 6 16.5C6 17.0523 6.44772 17.5 7 17.5H13C13.5523 17.5 14 17.0523 14 16.5C14 15.9477 13.5523 15.5 13 15.5H7Z"
        fill="#ffffff"
      ></path>{" "}
      <path
        d="M16 16.5C16 15.9477 16.4477 15.5 17 15.5H18C18.5523 15.5 19 15.9477 19 16.5C19 17.0523 18.5523 17.5 18 17.5H17C16.4477 17.5 16 17.0523 16 16.5Z"
        fill="#ffffff"
      ></path>{" "}
    </g>
  </svg>
);

export const referredIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    stroke="#000000"
    strokeWidth="0.01024"
  >
    <g strokeWidth="0">
      <rect width="1024" height="1024" rx="512" fill="#ffffff" />
    </g>
    <g>
      <path
        d="M512 128a192 192 0 1 0 0 384 192 192 0 0 0 0-384zM256 768c0-141.4 114.6-256 256-256s256 114.6 256 256v64H256v-64z"
        fill="#0F1F3C"
      />
      <path d="M704 384l128 128-128 128v-96H576v-64h128z" fill="#0F1F3C" />
    </g>
  </svg>
);

export const customerCategoryIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    stroke="#000000"
    strokeWidth="0.01024"
  >
    <g strokeWidth="0">
      <rect width="1024" height="1024" rx="512" fill="#ffffff" />
    </g>
    <g>
      <path
        d="M384 320a128 128 0 1 0 0 256 128 128 0 0 0 0-256zM640 320a128 128 0 1 0 0 256 128 128 0 0 0 0-256z"
        fill="#0F1F3C"
      />
      <path
        d="M192 768c0-106 86-192 192-192s192 86 192 192v64H192v-64zM448 768c0-106 86-192 192-192s192 86 192 192v64H448v-64z"
        fill="#0F1F3C"
      />
    </g>
  </svg>
);

export const referredCategoryIcon = (w = "80px", h = "80px") => (
  <svg
    width={w}
    height={h}
    viewBox="0 0 1024 1024"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    stroke="#000000"
    strokeWidth="0.01024"
  >
    <g strokeWidth="0">
      <rect width="1024" height="1024" rx="512" fill="#ffffff" />
    </g>
    <g>
      <path d="M256 256h384l128 128v384H256V256z" fill="#0F1F3C" />
      <path d="M512 448l128 128-128 128v-96H384v-64h128z" fill="#ffffff" />
    </g>
  </svg>
);
